"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SORT_OPTION_TYPE;

(function (SORT_OPTION_TYPE) {
  SORT_OPTION_TYPE[SORT_OPTION_TYPE["APP"] = 0] = "APP";
  SORT_OPTION_TYPE[SORT_OPTION_TYPE["ROW"] = 1] = "ROW";
})(SORT_OPTION_TYPE = exports.SORT_OPTION_TYPE || (exports.SORT_OPTION_TYPE = {}));

var SORT_OPTION_APP_TYPE;

(function (SORT_OPTION_APP_TYPE) {
  SORT_OPTION_APP_TYPE["EDIT_AT"] = "EDIT_AT";
  SORT_OPTION_APP_TYPE["CREATE_AT"] = "CREATE_AT";
  SORT_OPTION_APP_TYPE["TITLE"] = "TITLE";
  SORT_OPTION_APP_TYPE["SUBTITLE"] = "SUBTITLE";
  SORT_OPTION_APP_TYPE["CANCEL"] = "CANCEL";
})(SORT_OPTION_APP_TYPE = exports.SORT_OPTION_APP_TYPE || (exports.SORT_OPTION_APP_TYPE = {}));